<script setup>
import { computed } from 'vue';
import { SegmentedControlsProvider } from './useSegmendtedControls';

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['input', 'change']);

function onChange(value) {
  emit('input', value);
  emit('change', value);
}

SegmentedControlsProvider({
  rootValue: computed(() => props.value),
  onChange,
});
</script>

<template>
  <div
    class="inline-flex gap-1 rounded-lg bg-brand-gray-7 dark:bg-brand-gray-12 p-1"
    data-component="CsSegmentedControls"
  >
    <slot />
  </div>
</template>
